import React from 'react'

function Websitedesigning() {
  return (
    <>
    <section className="bg-gradient-to-br from-[#e710ea] to-black py-10 md:py-32">
        <div className="container mx-auto px-4 md:px-8 text-center">
          <h1 className="text-white font-bold font-serif text-4xl md:text-65l leading-tight mb-6 ">
          Website Designing Service's
          </h1>
          <p className="text-white text-lg md:text-2xl font-serif ">
          We offer website designing services that cater to modern business needs. Our design solutions are responsive, user-friendly,
          and optimized for performance. Our team ensures that your brand stands out in the digital space.
          </p>
        </div>
</section>
<section class="bg-zinc-50 overflow-hidden">
 <div class="max-w-screen-xl 2xl:max-w-screen-3xl px-8 md:px-12 mx-auto py-12 lg:py-24 space-y-24 xl:h-[540px] h-full flex flex-col justify-center">
  <div class="flex flex-col sm:flex-row mx-auto">
  <a href="#_">
    <img src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=2670&auto=format&fit=crop"
      class="rounded-xl rotate-6 hover:rotate-0 duration-500 hover:-translate-y-12 h-full w-full object-cover hover:scale-130 transform origin-bottom"
      alt="Website Development Workspace" />
  </a>
  <a href="#_">
    <img src="https://images.unsplash.com/photo-1498050108023-c5249f4df085?q=80&w=2670&auto=format&fit=crop"
      class="rounded-xl -rotate-12 hover:rotate-0 duration-500 hover:-translate-y-12 h-full w-full object-cover hover:scale-130 transform origin-bottom"
      alt="Designing Code Screen" />
  </a>
  </div> 
 </div>
</section>
    </>
  )
}

export default Websitedesigning